import moment from "moment";
import EverTrue from "app";

export const isPastDate = (date) => {
  const dueDate = moment.unix(date).format("YYYY-MM-DD");
  return moment(dueDate).isBefore(moment().format("YYYY-MM-DD"));
};

export const daysFromNow = (date) => {
  if (date) {
    const daysFromNow = moment.unix(date).startOf("day").diff(moment().startOf("day"), "days");

    switch (true) {
      case daysFromNow === 0:
        return { date: "Today" };
      case daysFromNow === 1:
        return { date: "Tomorrow" };
      case daysFromNow > 1:
        return { date: moment.unix(date).format("ddd MMM D, YYYY") };
      case daysFromNow === -1:
        return { date: moment.unix(date).format("ddd MMM D, YYYY"), msg: `(${Math.abs(daysFromNow)} day overdue)` };
      case daysFromNow < 0:
        return { date: moment.unix(date).format("ddd MMM D, YYYY"), msg: `(${Math.abs(daysFromNow)} days overdue)` };
      default:
        return "-";
    }
  }
};

export const formattedDate = (date) => {
  return moment.unix(date).format("MMM D, YYYY");
};

export const getEmptyStateMessageText = (userType, status) => {
  if (!userType) {
    if (status === "COMPLETED") {
      return "There are no completed tasks for this constituent";
    } else {
      return "You’re at a Fresh Start!";
    }
  } else {
    if (status === "COMPLETED") {
      if (userType === "OWNER") {
        return "You haven’t completed any tasks yet";
      } else {
        return "You don't have any completed tasks assigned to others";
      }
    } else {
      if (userType === "OWNER") {
        return "You’re at a Fresh Start!";
      } else {
        return "You haven’t assigned any tasks yet";
      }
    }
  }
};

export const getEmptyStateMessageSubtext = (userType, status) => {
  if (!userType) {
    if (status === "COMPLETED") {
      return "Tasks marked as complete will appear here.";
    } else {
      return `Begin by clicking "Add Task" to create a task for this profile.`;
    }
  } else {
    if (status === "COMPLETED") {
      return "Tasks marked as complete will appear here.";
    } else {
      if (userType === "OWNER") {
        return `Begin by clicking "Add Task" to create a task.`;
      } else {
        return `Begin by clicking "Add Task" to create a task for others in your team.`;
      }
    }
  }
};

export const trackTaskAction = (type, condition) => {
  const track = (type) => {
    EverTrue.track.set("tasks", { type });
  };
  const { pathname } = window.location;

  switch (type) {
    case "complete_task":
      if (pathname === "/tasks") {
        track("complete_task_from_task_screen");
      } else if (pathname.includes("/contact")) {
        track("complete_task_from_profile");
      }
      break;
    case "edit_task":
      if (pathname === "/tasks") {
        track("edit_task_task_page");
      } else if (pathname.includes("/contact")) {
        track("edit_task_profile");
      }
      break;
    case "delete_task":
      if (pathname === "/tasks") {
        track("delete_task_task_page");
      } else if (pathname.includes("/contact")) {
        track("delete_task_profile");
      }
      break;
    case "COMPLETED":
      if (pathname === "/tasks") {
        track("view_complete_task_task_page");
      } else if (pathname.includes("/contact")) {
        track("view_complete_tasks_profile");
      }
      break;
    case "IN_PROGRESS":
      if (pathname === "/tasks") {
        track("view_inprogress_tasks_task_page");
      } else if (pathname.includes("/contact")) {
        track("view_inprogress_tasks_profile");
      }
      break;
    case "ALL":
      if (pathname === "/tasks") {
        track("view_all_tasks_task_page");
      } else if (pathname.includes("/contact")) {
        track("view_all_tasks_profile");
      }
      break;
    case "update_notification":
      if (condition) {
        track("create_task_email_notification");
      } else {
        track("disable_task_email_notification");
      }
      break;
    case "add_task":
      if (pathname.includes("home")) {
        EverTrue.track.set("home_screen", { type: "add_task" });
      }
      break;
    default:
      track(type);
      break;
  }
};
